"use client";
import { Button } from "@/components/ui/Button";
import { H1 } from "@/components/ui/Heading";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import Image from "next/image";

export const AgentHubPromotion = () => {
  const t = useTranslations("home.agent-hub");

  return (
    <section className="w-full relative">
      <Image
        src={"c2ee9e0e-a60a-45a3-8216-254f40bffc00"}
        width={1366}
        height={768}
        alt="agent-hub-promotion"
        className="h-auto w-full object-cover max-h-[800px]"
      />

      <div className="absolute inset-0 bg-black/40" />
      <div className="absolute inset-0">
        <div className="w-full h-full flex flex-col text-center justify-center items-center py-[64px] px-[12px] sm:py-[160px] sm:px-[80px]">
          <H1 as={"h2"} className="!text-gray-100">
            {t("title")}
          </H1>
          <H1 as={"p"} className="!text-gray-100">
            {t("sub-title")}
          </H1>
          <Link href={"/agent-hub"}>
            <Button className="mt-8 min-h-9">{t("cta")}</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
